import { render, staticRenderFns } from "./GroupsCalendar.vue?vue&type=template&id=5ab0fb9d&scoped=true&"
import script from "./GroupsCalendar.vue?vue&type=script&lang=ts&"
export * from "./GroupsCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab0fb9d",
  null
  
)

export default component.exports